<template>
  <div>
    <h5 class="card-title">
      <i class="fas fa-calendar-times"></i>
      Pendências Internas Atrasadas
    </h5>

    <div v-if="loading" class="text-center">
      <b-spinner small></b-spinner>
      <span class="ml-2">Carregando...</span>
    </div>
    <div v-else-if="allPendencies.length === 0" class="text-muted text-center">
      <i class="fas fa-check-circle"></i>
      Nenhuma pendência atrasada encontrada
    </div>
    <div v-else>
      <div class="mb-3">
        <div>
          <b-badge variant="danger" class="mr-2">
            Total: {{ totalOverdue }}
          </b-badge>
          <small class="text-muted"
            >pendências internas com prazo expirado</small
          >
        </div>
      </div>

      <div class="list-container">
        <div class="list-header">
          <div class="row-content">
            <div class="protocol-section header-label">Protocolo</div>
            <div class="company-section header-label">Empresa</div>
            <div class="days-section header-label">Dias Atrasada</div>
            <div class="date-section header-label">Prazo Final</div>
            <div class="actions-section header-label">Ação</div>
          </div>
        </div>
        <div class="list-scroll" @scroll="handleScroll">
          <div
            v-for="pendency in visiblePendencies"
            :key="pendency._id"
            class="list-row"
            @click="viewPendency(pendency)"
          >
            <div class="row-content">
              <div class="protocol-section">
                <b-badge variant="secondary">{{
                  pendency.complaint.protocol
                }}</b-badge>
              </div>
              <div class="company-section">
                {{ pendency.companyName }}
              </div>
              <div class="days-section">
                <b-badge variant="danger"
                  >{{ Math.floor(pendency.daysOverdue) }} dias</b-badge
                >
              </div>
              <div class="date-section">
                {{ pendency.dueDate | date }}
              </div>
              <div class="actions-section">
                <b-button size="sm" variant="primary">Ver</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOverduePendencies } from "../../../../api/charts";

export default {
  name: "OverduePendencies",
  props: {
    companyId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      data: [],
      loading: true,
      limit: 15,
    };
  },
  computed: {
    allPendencies() {
      const pendencies = [];
      this.data.forEach((company) => {
        company.pendencies.forEach((pendency) => {
          pendencies.push({
            ...pendency,
            companyName: company._id.fantasyName || company._id.name,
          });
        });
      });
      return pendencies.sort((a, b) => b.daysOverdue - a.daysOverdue);
    },
    visiblePendencies() {
      return this.allPendencies.slice(0, this.limit);
    },
    totalOverdue() {
      return this.allPendencies.length;
    },
  },
  watch: {
    companyId() {
      this.fetchData();
    },
  },
  async created() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        this.limit = 15;
        const response = await getOverduePendencies(this.companyId);
        this.data = response.data;
      } catch (error) {
        console.error("Erro ao carregar pendências atrasadas:", error);
        this.$bvToast.toast("Erro ao carregar pendências atrasadas", {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 10000,
          noCloseButton: false,
        });
      } finally {
        this.loading = false;
      }
    },
    viewPendency(pendency) {
      this.$router.push(`/denuncias/${pendency.complaint._id}`);
    },
    handleScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        if (this.limit < this.allPendencies.length) {
          this.limit += 15;
        }
      }
    },
  },
};
</script>

<style scoped>
.list-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.list-header {
  padding: 0.75rem 1rem;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.header-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  text-transform: uppercase;
}

.list-scroll {
  max-height: 460px;
  overflow-y: auto;
}

.list-row {
  border-bottom: 1px solid #f1f3f4;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.list-row:hover {
  background-color: #f8f9fa;
}

.row-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.protocol-section {
  flex: 0 0 150px;
}
.company-section {
  flex: 1;
  padding: 0 1rem;
}
.days-section,
.date-section {
  flex: 0 0 150px;
  text-align: center;
}
.actions-section {
  flex: 0 0 100px;
  text-align: right;
}
</style>
